// Packages
import Vue from 'vue';

// Blocks
import ForumResultsVideo from '~scripts/blocks/vue/ForumResultsVideo.vue';

// Videos
const forumResultsVideos = document.querySelectorAll('.js-forum-results-video');
forumResultsVideos.forEach((video) => {
  new Vue({
    el: video,
    name: 'ForumResultsVideo',
    components: {
      ForumResultsVideo,
    },
  });
});
